import React from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

const CriteriaDialog = ({ open, onClose, note }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          "& .MuiDialogTitle-root": {
            backgroundColor: "#9c27b0",
            color: "white",
            fontWeight: 700,
            fontSize: "1.2rem",
            padding: "16px 24px",
          },
        },
      }}
    >
      <DialogTitle>과제 검사 기준</DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <ReactMarkdown
          remarkPlugins={[remarkBreaks, remarkGfm]}
          components={{
            p: ({ node, ...props }) => (
              <p style={{ marginBottom: "1em" }} {...props} />
            ),
            li: ({ node, ...props }) => (
              <li
                style={{ marginBottom: "0.5em", marginLeft: "1.5em" }}
                {...props}
              />
            ),
            ol: ({ node, ...props }) => (
              <ol style={{ paddingLeft: "1em", marginTop: "1em" }} {...props} />
            ),
            h1: ({ node, ...props }) => (
              <h1
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  marginBottom: "1em",
                }}
                {...props}
              />
            ),
            h2: ({ node, ...props }) => (
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: "0.8em",
                  marginTop: "1.2em",
                }}
                {...props}
              />
            ),
          }}
        >
          {note}
        </ReactMarkdown>
      </DialogContent>
    </Dialog>
  );
};

export default CriteriaDialog;
